var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMathPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.969,
    height: 54.516,
    viewBox: "0 0 60.969 54.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "math-plus",
    d: "M34.484,4a3.626,3.626,0,0,0-3.811,3.407V27.851H7.811A3.626,3.626,0,0,0,4,31.258a3.626,3.626,0,0,0,3.811,3.407H30.674V55.108a3.626,3.626,0,0,0,3.811,3.407,3.626,3.626,0,0,0,3.811-3.407V34.665H61.158a3.626,3.626,0,0,0,3.811-3.407,3.626,3.626,0,0,0-3.811-3.407H38.295V7.407A3.626,3.626,0,0,0,34.484,4Z",
    transform: "translate(-4 -4)",
    fill: "#ebe4fa"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathPlus);
export default __webpack_public_path__ + "static/media/math-plus.747581f08dfdb7f1f80cc8e7f0800c7c.svg";
export { ForwardRef as ReactComponent };